<template>
	<v-row no-gutters style="height: calc(100vh - 60px)">
		<v-col id="CCMViewContainer" cols="12">
			<div class="d-flex align-center w-100" v-if="$vuetify.breakpoint.smAndDown" style="background-color: white">
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<div style="background-color: #ff585f; border-radius: 4px" class="ma-1 pa-1">
							<v-icon size="30" color="white" v-bind="attrs" v-on="on">mdi-menu</v-icon>
						</div>
					</template>
					<v-list>
						<v-list-item v-for="tab in ccmTabs" :key="tab" @click="activeCCMTab = ccmTabs.indexOf(tab)">
							<v-list-item-title>{{ $t(tab) }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<div style="width: calc(100% - 30px)">
					<v-tabs
						:ripple="false"
						class="d-flex justify-center align-center background-white overview auto-width-tabs pr-5"
						:value="activeCCMTab"
						v-model="activeCCMTab"
						grow>
						<v-tab
							v-for="tab in ccmTabs"
							:key="tab"
							style="min-width: 0"
							:ripple="false"
							class="Overview_tab"
							:disabled="!selectedRecord">
							{{ $t(tab) }}
						</v-tab>
					</v-tabs>
				</div>
			</div>
			<template v-else>
				<v-tabs
					:ripple="false"
					class="d-flex justify-center align-center background-white overview auto-width-tabs"
					:value="activeCCMTab"
					v-model="activeCCMTab"
					grow>
					<v-tab
						v-for="tab in ccmTabs"
						:key="tab"
						style="min-width: 0"
						:ripple="false"
						class="Overview_tab"
						:disabled="!selectedRecord">
						{{ $t(tab) }}
					</v-tab>
				</v-tabs>
			</template>
			<!-- <v-row no-gutters class="ma-2">
				<v-col v-for="tab in ccmTabs" :key="tab" value="tab" class="flex-grow-0 flex-shrink-1">
					<button
						:value="activeCCMTab"
						class="btn"
						:class="activeCCMTab === ccmTabs.indexOf(tab) ? 'selected' : ''"
						style="width: auto !important"
						:disabled="!selectedRecord"
						@click="activeCCMTab = ccmTabs.indexOf(tab)">
						{{ $t(tab) }}
					</button>
				</v-col>
			</v-row> -->

			<v-row no-gutters style="height: calc(100vh - 108px)">
				<v-col v-if="!selectedRecord" class="pa-3">
					<v-card style="width: 100%; height: 100%" class="text-center d-flex flex-column justify-center align-center">
						<v-icon color="grey" size="50" class="mb-3">mdi-alert-circle-outline</v-icon>
						<p class="font-responsive-lg lightgrey">
							{{ $t('no-data-available') }}
						</p>
						<p class="font-responsive-md lightgrey">
							{{ $t('select-or-add-record') }}
						</p>
					</v-card>
				</v-col>

				<v-col v-else cols="12" style="height: 100%">
					<CCMRecordInfo v-if="activeCCMTab == ccmTabs.indexOf('info')" />
					<CCMConditions v-else-if="activeCCMTab == ccmTabs.indexOf('conditions')" />
					<CCMMedicationEvent v-else-if="activeCCMTab == ccmTabs.indexOf('medications')" />
					<CCMVitalEntry v-else-if="activeCCMTab == ccmTabs.indexOf('vitals')" />
					<CCMCarePlan v-else-if="activeCCMTab == ccmTabs.indexOf('care-plans')" />
					<CCMMedicalNote v-else-if="activeCCMTab == ccmTabs.indexOf('notes')" />
					<CCMVaccines v-else-if="activeCCMTab == ccmTabs.indexOf('vaccines')" />
					<CCMLabs v-else-if="activeCCMTab == ccmTabs.indexOf('labs')" />
					<CCMAttachments v-else-if="activeCCMTab == ccmTabs.indexOf('attachments')" />
					<!-- prettier-ignore -->
					<MonitoringPlans v-else-if="activeCCMTab == ccmTabs.indexOf('monitoring')" :computedPatientId="computedPatientId" />
					<CCMTimeLog v-else-if="activeCCMTab == ccmTabs.indexOf('time-logs')" />
					<CCMBilling v-else-if="activeCCMTab == ccmTabs.indexOf('billing')" />
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from 'vuex';
import CCMRecordInfo from '@/views/Client/components/ChronicCareManagement/CCMRecordInfo.vue';
import CCMConditions from '@/views/Client/components/ChronicCareManagement/CCMConditions.vue';
import CCMTimeLog from '@/views/Client/components/ChronicCareManagement/CCMTimeLog.vue';
import CCMCarePlan from '@/views/Client/components/ChronicCareManagement/CCMCarePlan.vue';
import CCMAttachments from '@/views/Client/components/ChronicCareManagement/CCMAttachments.vue';
import CCMMedicationEvent from '@/views/Client/components/ChronicCareManagement/CCMMedicationEvent.vue';
import CCMVitalEntry from '@/views/Client/components/ChronicCareManagement/CCMVitalEntry.vue';
import CCMMedicalNote from '@/views/Client/components/ChronicCareManagement/CCMMedicalNote.vue';
import MonitoringPlans from '@/views/Client/components/MonitoringPlans.vue';
import CCMBilling from '@/views/Client/components/ChronicCareManagement/CCMBilling.vue';
import CCMVaccines from '@/views/Client/components/ChronicCareManagement/CCMVaccines.vue';
import CCMLabs from '@/views/Client/components/ChronicCareManagement/CCMLabs.vue';

export default {
	name: 'CCMRecords',
	components: {
		CCMRecordInfo,
		CCMConditions,
		CCMTimeLog,
		CCMCarePlan,
		CCMMedicationEvent,
		CCMVitalEntry,
		CCMMedicalNote,
		MonitoringPlans,
		CCMBilling,
		CCMAttachments,
		CCMVaccines,
		CCMLabs,
	},

	data () {
		return {
			activeCCMTab: 0,
			ccmTabs: [
				'info',
				'conditions',
				'medications',
				'vitals',
				'care-plans',
				// 'observations',
				'notes',
				'vaccines',
				// 'imaging',
				'labs',
				'attachments',
				'monitoring',
				'time-logs',
				'billing',
			],
		};
	},

	computed: {
		...mapState({
			detailedUser: (state) => state.users.detailedUser,
			ccmRecords: (state) => state.ccmRecords.ccmRecordsByPatientId,
			selectedRecord: (state) => state.ccmRecords.ccmRecord,
		}),
		computedPatientId () {
			return this.detailedUser.medicalTeamData[0].patientId;
		},
	},

	mounted () {},
};
</script>

<style scoped lang="scss">
@import '@/scss/base/variables';

.auto-width-tabs :deep(.v-tab) {
	padding: 0 6px;
	width: auto !important;
}

@media only screen and (max-width: 960px) {
	/* hide the “prev” arrow on sm and down */
	:deep(.v-slide-group__prev) {
		display: none !important;
	}
}

// .btn {
// 	padding: 5px 10px;
// 	border-radius: 5px;
// 	min-height: 35px;
// 	white-space: nowrap;
// 	background-color: rgba($secondary, 0.5);
// 	font-weight: 500;
// 	text-transform: uppercase;
// 	transition-duration: 0.5s;
// 	&.selected {
// 		background-color: $primary;
// 		transition-duration: 0.5s;
// 	}
// }
</style>
